/**
 * Betragsformat des Statusberichts — eine Stelle statt dreier.
 *
 * `fmtEur` stand dreimal im Modul, in zwei Varianten: zweimal mit „–" für den
 * fehlenden Wert, einmal mit „– €" (Befund G9). Vereinheitlicht auf „–": Ein
 * Wert, den es nicht gibt, trägt auch keine Währung.
 */
export function formatEur(
  value: number | null | undefined,
  locale: string,
): string {
  if (value == null) return "–";
  return `${Math.round(value).toLocaleString(locale)} €`;
}

/**
 * Stundenangabe des Berichts — immer zwei Nachkommastellen im Zahlenformat des
 * Berichts (Befund B4).
 *
 * Im kundensichtbaren HTML stand „25.75 h" mit englischem Dezimalpunkt
 * (`toFixed`, das kein Zahlenformat kennt), während dieselbe Zahl im
 * Mail-Entwurf korrekt „25,75 h" hieß und die Euro-Beträge daneben ebenfalls
 * deutsch formatiert waren. Zwei Formate für denselben Wert, und der falsche
 * stand ausgerechnet dort, wo der Kunde hinsieht.
 *
 * Die zwei Nachkommastellen sind Absicht und kein Nebeneffekt: Die Stunden
 * werden auf Viertelstunden gerundet, „0,50 h" ist die gewohnte Schreibweise
 * einer halben Stunde — `toLocaleString` allein hätte „0,5 h" geliefert.
 */
export function formatHours(value: number, locale: string): string {
  return `${value.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} h`;
}

/** „Juli 2026" im übergebenen Zahlen-/Datumsformat. */
export function formatMonth(month: string, locale: string): string {
  const [year, mon] = month.split("-");
  const d = new Date(Date.UTC(Number(year), Number(mon) - 1, 1));
  return d.toLocaleDateString(locale, {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}
